import { useMemo } from 'react';
import { Row, Col, Collapse, Spin } from 'antd';
import SignedIcon from '../../../images/SignedIcon.svg';
import NotSignedIcon from '../../../images/NotSignedIcon.svg';
import useSignatureData from '../hooks/useSignatureData';
import { useTranslation } from 'react-i18next';
import { orderBy } from 'lodash';

const { Panel } = Collapse;

const ExpertRecords = ({ currentExamTab }) => {
  const { t } = useTranslation();
  const { examData, loading } = useSignatureData(currentExamTab.admission_patient_exam_id, t);

  const expertFields = useMemo(() => {
    let expertFields = examData?.expert_fields || [];
    if (examData?.extra_data?.expertFieldGroups?.length > 0) {
      expertFields = expertFields.filter((field) => {
        const group = examData.extra_data.expertFieldGroups.find((group) => group.codes.includes(field.code));
        if (group) {
          return Object.entries(group.conditions).every(([conditionKey, expectedValue]) => {
            const conditionResult = expertFields.find((input) => input.code === conditionKey).result;
            return conditionResult === expectedValue;
          });
        } else {
          return true;
        }
      });
    }
    return expertFields ? orderBy(expertFields, (exam) => exam.order, ['asc']) : [];
  }, [examData?.expert_fields, examData?.extra_data?.expertFieldGroups]);

  return (
    <Row justify="end" className="expert-report-wrapper mb-40">
      <Col lg={12} xs={24}>
        <Spin className="cmt-spin" spinning={loading}>
          {currentExamTab.is_signed && examData ? (
            <Row>
              <Col lg={24} xs={24}>
                <Row gutter={10}>
                  <Col>
                    <img src={SignedIcon} alt="Icono firmado" width={20} />
                  </Col>
                  <Col>
                    <p className="signed-text">Firmado por especialista</p>
                  </Col>
                </Row>
              </Col>
              <Col lg={24} xs={24}>
                <Collapse>
                  <Panel header={<p className="mb-0">Antecedentes Especialista</p>} key="0">
                    <Row className="collapse-items">
                      {expertFields.map((item, index) => {
                        if (item.input_type === 'diagnostic') {
                          return (
                            <Col key={index} className={`pr-30 pl-30 pt-20 pb-20 ${index > 0 && 'item-with-top-border'}`} lg={24} xs={24}>
                              <h4>{item.name}</h4>
                              {item?.result?.map((diagnostic) => {
                                return (
                                  <div className="item-with-top-border mt-20">
                                    <div className="pt-20">
                                      <strong>{diagnostic.code}</strong> - {diagnostic.description}
                                    </div>
                                    <br />
                                    <div>
                                      <strong>Recomendaciones:</strong>
                                      <p dangerouslySetInnerHTML={{ __html: diagnostic?.indication?.replaceAll('\n', '<br />') }} />
                                    </div>
                                  </div>
                                );
                              })}
                            </Col>
                          );
                        }
                        return (
                          <Col key={index} className={`pr-30 pl-30 pt-20 pb-20 ${index > 0 && 'item-with-top-border'}`} lg={24} xs={24}>
                            <h4>{item.name}</h4>
                            {item.result && <p className="mb-0">{item.result}</p>}
                          </Col>
                        );
                      })}
                      <Col lg={24} xs={24} className="pr-30 pl-30 pt-20 pb-20 item-with-top-border">
                        <h4>Nombre de Médico Firmante</h4>
                        <p className="mb-0">{examData.expert_name}</p>
                      </Col>
                      <Col lg={24} xs={24} className="pr-30 pl-30 pt-20 pb-20 item-with-top-border">
                        <h4>Especialidad</h4>
                        <p className="mb-0">{examData.expert_specialty || '-'}</p>
                      </Col>
                      {(expertFields.filter(field => field.input_type === 'diagnostic').length === 0 || examData.diagnostics?.length > 0) && (
                      <Col lg={24} xs={24} className="pr-30 pl-30 pt-20 pb-20 item-with-top-border">
                        <h4>Diagnósticos</h4>
                        {examData.diagnostics?.map((diagnostic) => {
                          return (
                            <div className="item-with-top-border mt-20">
                              <div className="pt-20">
                                <strong>{diagnostic.code}</strong> - {diagnostic.description}
                              </div>
                              <br />
                              <div>
                                <strong>Recomendaciones:</strong>
                                <p dangerouslySetInnerHTML={{ __html: diagnostic?.indication?.replaceAll('\n', '<br />') }} />
                              </div>
                            </div>
                          );
                        })}
                      </Col>)}
                    </Row>
                  </Panel>
                </Collapse>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col lg={24} xs={24}>
                <Row gutter={10}>
                  <Col>
                    <img src={NotSignedIcon} alt="Icono no firmado" width={20} />
                  </Col>
                  <Col>
                    <p className="not-signed-text">
                      <strong>Requiere</strong> firma de especialista
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col lg={24} xs={24}>
                <Collapse>
                  <Panel header={<p className="mb-0">Antecedentes Especialista</p>} key="0" collapsible="disabled" />
                </Collapse>
              </Col>
            </Row>
          )}
        </Spin>
      </Col>
    </Row>
  );
};

export default ExpertRecords;
